import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Seo from "@/components/Seo";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Seo
        title="Seite nicht gefunden | SR-Zerspanung"
        description="Diese Seite existiert nicht. Zurück zur Startseite von SR-Zerspanung – CNC-Fertigung aus Stamsried."
        path={location.pathname}
        noindex
      />
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 pt-32 pb-20">
        <div className="text-center max-w-lg">
          <p className="font-heading font-bold text-6xl text-primary mb-4">404</p>
          <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground mb-4">
            Diese Seite gibt es nicht
          </h1>
          <p className="text-muted-foreground mb-8">
            Der Link ist veraltet oder wurde falsch eingegeben. Hier geht es weiter:
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-primary">
            <a href="/" className="underline hover:text-primary/80 transition-colors">Startseite</a>
            <a href="/leistungen" className="underline hover:text-primary/80 transition-colors">Leistungen</a>
            <a href="/anfrage" className="underline hover:text-primary/80 transition-colors">Anfrage stellen</a>
            <a href="/team" className="underline hover:text-primary/80 transition-colors">Team</a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
